export default __webpack_public_path__ + "static/Montserrat-500italic-5146cbfe02b1deea5dffea27a5f2f998.woff";